import { Button, HStack } from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from 'types/RequestStatus';

export const ReviewFooter: React.FunctionComponent<{
	onSubmitted: () => void;
	onCloseModal: () => void;
	postMarkReviewedStatus: RequestStatus;
}> = ({ onSubmitted, onCloseModal, postMarkReviewedStatus }) => (
	<HStack gap="md">
		<Button
			text={'Mark as reviewed'}
			size="md"
			type="submit"
			isLoading={postMarkReviewedStatus === RequestStatus.LOADING}
			loadingText="Updating..."
			onClick={onSubmitted}
			isDisabled={postMarkReviewedStatus === RequestStatus.LOADING}
		/>
		<Button
			text="Cancel"
			size="md"
			variant="secondary"
			onClick={onCloseModal}
		/>
	</HStack>
);
